module.exports = __webpack_public_path__ + "static/josefin-sans-latin-300-fd4f0b8d7231e6937ed4fe227ba586a9.woff2";